export const scoreColor = (score: number) => {
  // NOTE: these class names are enumerated literally (rather than using a dynamic expression
  // like `bg-score-${score}`) to ensure that the tailwind preprocessor recognizes them.
  // TODO: these classes give the same effect as a combination of `score` and `value-<N>`
  // classes as is used in the ScoreIcon component. We should consolidate these definitions.
  return {
    0: "bg-score-0",
    1: "bg-score-1",
    2: "bg-score-2",
    3: "bg-score-3",
    4: "bg-score-4",
    5: "bg-score-5",
  }[score];
};

export const scoreDescriptionBackgroundColor = (score: number) => {
  // NOTE: these class names are enumerated literally (rather than using a dynamic expression
  // like `bg-score-light-${score}`) to ensure that the tailwind preprocessor recognizes them.
  return {
    0: "bg-score-light-0",
    1: "bg-score-light-1",
    2: "bg-score-light-2",
    3: "bg-score-light-3",
    4: "bg-score-light-4",
    5: "bg-score-light-5",
  }[score];
};
